export const COLOR_SCHEME_STORAGE_KEY = "m360.color-scheme";

export type ColorScheme = "light" | "dark";

const isColorScheme = (value: unknown): value is ColorScheme => value === "light" || value === "dark";

export function readStoredColorScheme(): ColorScheme {
  try {
    const stored = window.localStorage.getItem(COLOR_SCHEME_STORAGE_KEY);
    return isColorScheme(stored) ? stored : "light";
  } catch {
    return "light";
  }
}

export function persistColorScheme(scheme: ColorScheme): void {
  try {
    window.localStorage.setItem(COLOR_SCHEME_STORAGE_KEY, scheme);
  } catch {
    // Preference is best-effort; a failed write leaves the prior stored scheme in place after reload.
  }
}

export function applyColorSchemeClass(scheme: ColorScheme): void {
  document.documentElement.classList.toggle("dark", scheme === "dark");
}
